import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import * as FingerprintJS from "@fingerprintjs/fingerprintjs-pro";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import axios from "axios";
import Cookies from "universal-cookie";
import {
  deploymentTypes,
  selected_authentication_server,
  servers,
  serverType,
} from "../../deployment-config";

import { FloatLabelInput, LoadingButton } from "../../Utils/CustomComponent";
import urls from "../../Utils/urls";
import { commonToast } from "../../Utils";
import {
  Background,
  OTPInputComponent,
  setUser,
  useSetUserLoggedIn,
} from "./LoginComp";
import logo from "./../../assets/SLS_website_logo.png";

let server_address =
  serverType === deploymentTypes.development
    ? servers.development
    : deploymentTypes.localDevelopment
    ? servers.localDevelopment
    : servers.production;

export const environment_hostname = `https://${server_address}/api/v1`;

const PartnerFlowLogin = () => {
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    // setValue,
  } = useForm();
  const dispatch = useDispatch();
  const [otpReceived, setOtpReceived] = useState("");
  const [otpEntered, setOtpEntered] = useState("");
  const [showOtpInput, setShowOtpInput] = useState(false);
  const [isOtpStage, setIsOtpStage] = useState(false);
  const [afterOtpLoading, setAfterOtpLoading] = useState(false);
  const [disableFWS, setDisableFWS] = useState(false);
  const [promptFail, setPromptFail] = useState(null);
  // const [firstLogin, setFirstLogin] = useState(true);
  const [trustedDevice, setTrustedDevice] = useState(false);
  const [userId, setUserId] = useState(null);
  const [firstStepDone, setFirstStepDone] = useState(false);
  const [fingerprintId, setFingerprintId] = useState(null);

  const [cookies] = useState(new Cookies());
  const watchValue = watch();
  // const email = watch("email");
  // const isSuperiorLoanEmail =
  //   email && email.includes("@superiorloanservicing.com");
  const [disableBtn, setDisableBtn] = useState(false);

  async function getFingerPrint() {
    try {
      const fp = await FingerprintJS.load({
        apiKey: "xzMefaISTzTk3XMDEH6r",
        endpoint: "https://metrics.loanlinq.com",
        scriptUrlPattern: [
          "https://metrics.loanlinq.com/web/v<version>/<apiKey>/loader_v<loaderVersion>.js",

          // The default endpoint will be used if the primary fails
          FingerprintJS.defaultScriptUrlPattern,
        ],
      });
      const result = await fp.get();
      const fingerprint = result.visitorId;

      return fingerprint;
    } catch (error) {
      console.error(error);
    }
  }

  const handleInitialLogin = async (email) => {
    setDisableFWS(true);
    try {
      const fingerprint = await getFingerPrint();
      setFingerprintId(fingerprint);

      const res = await axios.post(
        // `${environment_hostname}/auth/get_auth_token`,
        // `http://localhost:8090/api/v1/auth/get_auth_token`,
        urls.admin.partnerFlowAuthAPI,
        { UserName: email, fingerprint: fingerprint },
        selected_authentication_server.access_account.headers
      );

      if (res.data?.is_trusted) {
        await finalApiCall(fingerprint);
      } else if (!res.data?.is_trusted) {
        // const decodedOtp = atob(res.data.otp); // Decode OTP

        // setOtpReceived(decodedOtp);
        setShowOtpInput(true);
        setIsOtpStage(true);
        setPromptFail(null);
      }
    } catch (error) {
      console.error("Login failed:", error);
      if (
        error?.message?.includes(
          "The operation is not allowed at this time because the page does not have focus."
        )
      ) {
        alert(
          "This page must remain active to validate the device as trusted. Please try again and do not navigate away until the verification is complete."
        );
      } else {
        setPromptFail("Invalid email. Please try again.");
      }
      setDisableFWS(false);
    }
  };

  async function finalApiCall(fingerprint) {
    try {
      if (trustedDevice) {
        await trustDevice(watchValue?.email);
      }

      const hash = await getLoginHash(watchValue?.email, fingerprint);
      // console.log({ hash });

      handleNavigation(hash);
    } catch (error) {
      console.error(error);
    }
  }

  async function sha256(message) {
    // console.log({ message });
    // UTF-8 encoding (matches STANDARD_HASH)
    const data = new TextEncoder().encode(message);

    const hashBuffer = await crypto.subtle.digest("SHA-256", data);

    // Oracle displays RAW as uppercase hex
    return Array.from(new Uint8Array(hashBuffer))
      .map((b) => b.toString(16).padStart(2, "0"))
      .join("")
      .toUpperCase();
  }

  async function getLoginHash(username, fingerprint = null) {
    if (fingerprint) {
      const combined = username + fingerprint;
      return await sha256(combined);
    } else {
      return await sha256(username);
    }
  }

  function handleNavigation(hash) {
    // console.log({ hash });
    const link = document.createElement("a");
    link.href = `https://partnerflow.loanlinq.com/ords/f?p=106:PFREDIRECT::::PFREDIRECT:SHA256:${hash}:`;
    link.target = "_self"; // Opens in new tab
    link.rel = "noopener noreferrer"; // Security best practices
    document.body.appendChild(link); // Required for Firefox
    link.click();
    document.body.removeChild(link);
  }

  const onSubmit = async (data) => {
    localStorage.setItem("email_for_forgot_password", data.email);
    setDisableFWS(true);
    if (isOtpStage) {
      if (otpEntered?.length === 6) {
        try {
          setAfterOtpLoading(true);

          const data2 = {
            UserName: data.email,
            otp: otpEntered,
          };
          const res3 = await axios.post(
            urls.admin.validateLoginOTP,
            data2,
            selected_authentication_server.access_account.headers
          );
          // Second API call if OTP is correct
          if (res3.status == 200) {
            if (trustedDevice) {
              await trustDevice(data.email);
              const hash = await getLoginHash(data.email, fingerprintId);
              // console.log({ hash });
              handleNavigation(hash);
            } else if (!trustedDevice) {
              const hash = await getLoginHash(data.email);

              handleNavigation(hash);
            }
          }
        } catch (error) {
          console.error("Failed to verify user:", error);
          setPromptFail("Failed to verify OTP. Please try again.");
        }
      } else {
        // setPromptFail("Invalid OTP. Please try again.");
        setPromptFail("Please enter a 6 digit valid OTP!");
      }
      setAfterOtpLoading(false);
    } else {
      handleInitialLogin(data.email);
    }
  };

  async function onSubmit1(data) {
    setDisableBtn(true);
    try {
      const res = await axios.post(
        urls.admin.getUserByEmailForPartnerFlow,
        { UserName: data.email },
        selected_authentication_server.access_account.headers
      );

      // console.log(res?.data?.response);

      if (res?.data?.response === '{"User exists."}') {
        onSubmit(data);
        setFirstStepDone(true);
      }
    } catch (error) {
      console.error(error);
      if (error.status == 403) {
        setPromptFail("User not found.");
      }
      setFirstStepDone(false);
    } finally {
      setDisableBtn(false);
    }
  }

  async function trustDevice(email) {
    try {
      const fingerprint = await getFingerPrint();

      const data = JSON.stringify({
        USER_NAME: email,
        DEVICE_FINGERPRINT: fingerprint,
      });
      await axios.post(
        urls.admin.partnerFlowRegisterForTrustedDevice,
        data,
        selected_authentication_server.access_account.headers
      );

      toast.success("Device successfully registered as a trusted device!", {
        ...commonToast,
      });
    } catch (error) {
      console.error(error);
      toast.error("Trusted device registration failed!", {
        ...commonToast,
      });
    }
  }

  return (
    <Background showFooter={false} logo={logo}>
      {/* <LoginPopup showPopup={showPopup} setShowPopup={setShowPopup} /> */}
      <form className="w-75">
        <h3>PartnerFlow</h3>
        <p className="pb-5 mb-3">Please enter your login details to proceed.</p>

        <div className="form-outline mb-5">
          <FloatLabelInput
            register={{
              ...register("email", {
                required: true,
                pattern:
                  // eslint-disable-next-line no-useless-escape
                  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
              }),
            }}
            label={"Email"}
            value={watchValue?.email}
            disabled={firstStepDone ? true : disableFWS}
            defaultValue={""}
            error={errors.email ? "Email Required" : ""}
            type="email"
          />
        </div>

        <div className="form-outline mb-1">
          {showOtpInput && (
            <>
              <OTPInputComponent
                setOtpEntered={setOtpEntered}
                setOtpReceived={setOtpReceived}
                onClick={() => handleInitialLogin(watchValue?.email)}
              />
            </>
          )}
        </div>

        <div className="text-center pt-1 mt-5 mb-5 pb-1">
          {showOtpInput ? (
            <>
              <LoadingButton
                className="btn btn-primary w-100 btn-block fa-lg gradient-custom-2 mb-3 text-white"
                type="button"
                onClick={handleSubmit(onSubmit)}
                title={"Verify OTP and Continue"}
                disabled={afterOtpLoading}
                loading={afterOtpLoading}
              />
              {/* <TrustDevicePrompt userId={userId} /> */}
              <div className="text-start linkClick text-decoration-underline">
                <Form.Check
                  type={"checkbox"}
                  id={"trusted-device"}
                  label={`Remember this device for next 30 days`}
                  checked={trustedDevice}
                  onChange={(e) => {
                    setTrustedDevice(e.target.checked);
                  }}
                />
              </div>
            </>
          ) : (
            <>
              {firstStepDone ? (
                <LoadingButton
                  className="btn btn-primary w-100 btn-block fa-lg gradient-custom-2 mb-3 text-white"
                  type="button"
                  onClick={handleSubmit(onSubmit)}
                  disabled={disableFWS}
                  loading={disableFWS}
                  title={"Continue"}
                />
              ) : (
                <LoadingButton
                  className="btn btn-primary w-100 btn-block fa-lg gradient-custom-2 mb-3 text-white"
                  type="button"
                  onClick={handleSubmit(onSubmit1)}
                  disabled={disableBtn}
                  loading={disableBtn}
                  title={"Next"}
                />
              )}
            </>
          )}

          {promptFail && (
            <div className="alert alert-error" role="alert">
              {promptFail}
            </div>
          )}
          <br />
        </div>
      </form>
    </Background>
  );
};
export default PartnerFlowLogin;

const cleanLocalStorage = () => {
  localStorage.removeItem("user");
  localStorage.removeItem("setupTime");
};
const setTimeForLoginSession = () => {
  var hours = 1;
  var now = new Date().getTime();
  var setupTime = localStorage.getItem("setupTime");
  if (setupTime == null) {
  } else {
    if (now - setupTime > hours * 60 * 60 * 1000) {
      cleanLocalStorage();
    }
  }
};
